import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'

const TextCellRenderer = ({ value }: ICellRendererParams): ReactElement => {
  return (
    <div className="text">
      <span>{value}</span>
    </div>
  )
}

export const FormatTextCellRenderer = ({ valueFormatted }: ICellRendererParams): ReactElement => {
  return (
    <div className="text">
      <span>{valueFormatted}</span>
    </div>
  )
}

export default TextCellRenderer
